<template>
  <tr>
    <td>
      {{ item.voucherCode }}
    </td>

    <td>
      {{ item.useCounter }}
    </td>

    <td>
      {{ expirationDate }}
    </td>

    <td>
      {{ item.comment }}
    </td>

    <td>
      <i class="mdi mdi-delete pointer"
         v-tooltip="'Deletar'"
         @click.stop="deleteClient"></i>
    </td>

  </tr>
</template>

<script>
import EventBus from "@packages/event-bus/index";

export default {
  components: {},

  data() {
    return {};
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    expirationDate() {
      const value = this.item.expirationDate;

      return value ? this.$date.format(value) : '';
    },
  },

  methods: {
    emitReload() {
      this.$emit("reload");
    },
    async deleteClient() {
      await this.$api.core.voucher.client.delete({
        clientId: this.item.id,
      });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Cliente deletado com sucesso",
      });

      this.$emit("deleted");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
